import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/style.css";
import { auth, db } from "./firebase";
import { Element, scroller } from "react-scroll";
import firebase from "firebase/compat/app";
import FirewallUsageChart from "./FirewallUsageChart";
 import MiniSIEMLab from "./components/MiniSIEMLab";

const Chapter4_3 = () => {
  const navigate = useNavigate();
  const [selectedAnswers, setSelectedAnswers] = useState({ q1: "", q2: "" });
  const [error, setError] = useState("");
  const [userId, setUserId] = useState(null);

  const questions = [
    {
      question: "Frage 1: Was ist die Aufgabe einer Firewall?",
      options: [
        {
          value: "A",
          label:
            "Das Überwachen und Analysieren aller eingehenden und ausgehenden Datenpakete.",
        },
        {
          value: "B",
          label: "Das Verschlüsseln des Datenverkehrs.",
        },
      ],
      correct: "A",
    },
    {
      question:
        "Frage 2: Was ist der Unterschied zwischen einem IDS und einem IPS?",
      options: [
        {
          value: "A",
          label:
            "Ein IDS erkennt und meldet verdächtige Aktivitäten, während ein IPS Angriffe aktiv blockiert.",
        },
        {
          value: "B",
          label:
            "Ein IDS überwacht den internen Datenverkehr, während ein IPS nur den externen Verkehr überprüft.",
        },
      ],
      correct: "A",
    },
  ];
  const location = useLocation(); 

 
  useEffect(() => {
    if (location.hash) {
      scroller.scrollTo(location.hash.substring(1), {
        duration: 500,
        smooth: true,
        offset: -50,
      });
    }
  }, [location]);

 
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUserId(user.uid); 
      } else {
        console.error("Kein authentifizierter Benutzer gefunden");
        setError("Benutzer ist nicht authentifiziert");
        navigate("/cybersecurity/login"); 
      }
    });

    
    return () => unsubscribe();
  }, [navigate]);

  
  useEffect(() => {
    console.log("Aktuelle userId in 4_3.js:", userId);
  }, [userId]);

  const handleLogout = () => {
    
    auth
      .signOut()
      .then(() => {
        
        window.location.href = "/login"; 
      })
      .catch((error) => {
        console.error("Logout fehlgeschlagen:", error);
      });
  };

  const handleAnswerChange = (questionIndex, value) => {
    setSelectedAnswers((prev) => ({
      ...prev,
      [questionIndex]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const correctAnswers = questions.every(
      (q, index) => selectedAnswers[index] === q.correct
    );

    if (correctAnswers) {
      try {
        if (!userId) {
          console.error("userId ist nicht definiert");
          setError("Ein Fehler ist aufgetreten.");
          return;
        }

        
        const userDoc = await db.collection("cybersecurityProgress").doc(userId).get();

        console.log("userDoc:", userDoc.exists); 

        if (userDoc.exists) {
          
          await db
            .collection("cybersecurityProgress")
            .doc(userId)
            .update({
              lastChapter: "4_3",
              completedChapters:
                firebase.firestore.FieldValue.arrayUnion("4_3"),
            });
          console.log("Dokument aktualisiert mit Kapitel 4_3.");
        } else {
          
          await db
            .collection("cybersecurityProgress")
            .doc(userId)
            .set({
              lastChapter: "4_3",
              completedChapters: ["4_3"],
            });
          console.log("Dokument erstellt mit Kapitel 4_3");
        }

        navigate("/cybersecurity/4_4"); 
      } catch (error) {
        console.error("Fehler beim Aktualisieren des Fortschritts:", error);
        setError("Ein Fehler ist aufgetreten. Versuche es später erneut.");
      }
    } else {
      setError("Die Antworten sind nicht korrekt. Versuche es erneut.");
    }
  };
  return (
    <div className="container">
      <div className="container py-5">
        <img
          src="/images/zebbs_Logo.svg"
          class="d-block mx-auto mb-4"
          alt=""
          style={{ width: "20%" }}
        />
        <div className="d-flex justify-content-between align-items-center mb-5 p-3 bg-body-tertiary rounded-3">
          {/* Breadcrumbs */}
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb breadcrumb-chevron mb-0">
              {/* Startseite (Home) */}
              <li className="breadcrumb-item">
                <Link className="link-body-emphasis" to="/cybersecurity/course-overview">
                  <i className="bi bi-house-door-fill"></i>
                  <span className="visually-hidden">Home</span>
                </Link>
              </li>

              {/* Library Link */}
              <li className="breadcrumb-item">
                <Link
                  className="link-body-emphasis fw-semibold text-decoration-none"
                  to="/cybersecurity/course-overview"
                >
                  Kapitel 4: Netzwerk und Netzwerksicherheit
                </Link>
              </li>

              {/* Aktuelle Seite */}
              <li className="breadcrumb-item active" aria-current="page">
                Netzwerksicherheit
              </li>
            </ol>
          </nav>

          {/* Logout-Button */}
          <button className="btn btn-outline-dark" onClick={handleLogout}>
            Logout
          </button>
        </div>

        <div
          className="p-5 m-0 rounded-3"
          style={{
            position: "relative",
            backgroundColor: "#009fe0",
            margin: "25px",
            textAlign: "center",
          }}
        >
          <h3 className="text-center p-3">
            4. Netzwerk und Netzwerksicherheit
          </h3>
          <h2 className="text-center p-3">Netzwerksicherheit</h2>
          <img
            src="/images/firew.svg"
            alt="firewall"
            style={{ position: "relative", maxWidth: "20%", height: "auto" }}
          />
        </div>

        <div className="p-5 text-center">
          <h3 className="p-5">Schichtenbasierte Sicherheitsstrategie</h3>
          <p className="col-lg-11 mx-auto">
            In der Netzwerksicherheit wird oft das Konzept der mehrschichtigen
            Verteidigung <strong> Defense in Depth </strong> (oder Layered
            Security) angewendet. Dabei geht es darum, verschiedene
            Schutzmechanismen in mehreren Schichten zu kombinieren, um
            potenziellen Angreifern möglichst viele Hindernisse zu bieten,
            selbst wenn eine Schutzmaßnahme überwunden wird.
            <br />
            <br />
            Neben den bekannten Cybersecurity-Sicherheitsmaßnahmen wie Antivirus
            und{" "}
            <Link to="/cybersecurity/3_1" className="icon-link">
              {" "}
              <svg className="bi" aria-hidden="true">
                {" "}
                <use xlinkHref="#book"></use>{" "}
              </svg>{" "}
              Anti-Malware,{" "}
            </Link>{" "}
            der Schulung von Mitarbeitern zur{" "}
            <Link to="/cybersecurity/2_2#saw" className="icon-link">
              <svg className="bi" aria-hidden="true">
                <use xlinkHref="#book"></use>
              </svg>{" "}
              Security Awareness
            </Link>{" "}
            und der{" "}
            <Link to="/cybersecurity/2_3#mfa" className="icon-link">
              <svg className="bi" aria-hidden="true">
                <use xlinkHref="#book"></use>
              </svg>{" "}
              Multi-Faktor-Authentifizierung (MFA),
            </Link>{" "}
            gibt es spezielle Methoden und Technologien für eine effektive
            Netzwerksicherheit:
          </p>{" "}
        </div>
      </div>

      <div className="grey-section">
        <div className="container">
          <div className="p-5 text-center">
            <Element name="firewall">
              <h2 className="p-5">Firewalls</h2>
              <p className="col-lg-11 mx-auto">
                Eine Firewall ist ein Sicherheitssystem, das ein
                Computernetzwerk vor unerwünschten Zugriffen schützt. Sie
                fungiert als Filter zwischen einem internen Netzwerk (z. B.
                dem Heimnetzwerk oder Unternehmensnetzwerk) und dem Internet.
                Die Hauptaufgabe einer Firewall besteht darin, den Datenverkehr
                zu überwachen und anhand festgelegter Sicherheitsregeln zu
                entscheiden, ob dieser zugelassen oder blockiert wird.
                <br />
                Es gibt zwei Arten von Firewalls: Hardware-Firewalls und
                Software-Firewalls.
                <br />
                <br />
                Eine <strong>Hardware-Firewall </strong>ist ein eigenständiges
                physisches Gerät, das zwischen dem internen Netzwerk (z. B. dem
                Heimnetzwerk) und dem externen Netzwerk (z. B. dem Internet)
                platziert wird. Sie funktioniert wie eine Barriere und überwacht
                den gesamten Datenverkehr, der in das Netzwerk hinein- und
                hinausfließt. Hardware-Firewalls werden meist zentral verwaltet
                und zum Beispiel als physisches Gerät zwischen dem Router und
                dem Internet eingebaut. Eine Hardware-Firewall bietet einen
                umfassenden Schutz für das <strong>gesamte Netzwerk </strong>und
                ist sehr leistungsstark, erfordert aber mehr Aufwand bei der
                Einrichtung als eine Software-Firewall. Hardware-Firewalls
                eignen sich daher besonders für Unternehmen oder große
                Netzwerke.
                <br />
                <br />
                Eine <strong>Software-Firewall </strong>ist ein Programm, das
                nur auf einem Computer installiert wird. Sie überwacht und
                filtert den Datenverkehr nur für{" "}
                <strong>diesen spezifischen Computer. </strong>
                Software-Firewalls sind einfach zu installieren und können
                individuell angepasst werden. Sie sind ideal, um individuelle
                Geräte zu schützen, vor allem in Situationen, in denen diese
                Geräte außerhalb des Unternehmensnetzwerks arbeiten, z. B. bei
                Remote-Arbeit oder zum Schutz persönlicher Computer.
                <br />
                <br />
              </p>
              <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
                <img
                  src="/images/fact.svg"
                  alt="Transparent"
                  style={{
                    position: "relative",
                    maxWidth: "8%",
                    height: "auto",
                  }}
                />
                Der Begriff "Firewall" kommt aus der Architektur und wurde
                ursprünglich verwendet, um eine Schutzwand zu beschreiben, die
                in Gebäuden installiert wurde, um die Ausbreitung eines Feuers
                zu verhindern. Solche Wände bestanden aus feuerfestem
                Material und sollten gewährleisten, dass das Feuer auf einen
                bestimmten Bereich beschränkt bleibt. Die Analogie zur
                Netzwerksicherheit ist dabei ziemlich passend: Eine Firewall im
                IT-Bereich blockiert schädlichen Datenverkehr und verhindert,
                dass Bedrohungen (oder "Feuer") in ein sicheres Netzwerk
                eindringen oder sich dort ausbreiten.
              </p>
              <h2 className="p-5">Wie funktioniert eine Firewall?</h2>
              <p className="p-3 col-lg-11 mx-auto">
                Eine Firewall – ob als Hardware- oder Softwarelösung – setzt
                verschiedene Techniken ein, um den Datenverkehr zu überwachen
                und unberechtigte Zugriffe zu verhindern.
                <br />
                <br />
                Die Firewall{" "}
                <strong>
                  {" "}
                  überwacht und analysiert alle eingehenden und ausgehenden
                  Datenpakete.{" "}
                </strong>
                Sie prüft dabei Aspekte wie die Absender- und Empfängeradresse
                (IP-Adresse), den Port, das verwendete Protokoll (z. B. HTTP,
                HTTPS) und den Inhalt der Pakete.
                <br />
                <br />
                Firewalls arbeiten mit{" "}
                <strong> Regeln und Richtlinien, </strong> die definieren,
                welcher Datenverkehr erlaubt ist und welcher blockiert wird. Zum
                Beispiel kann eine Regel festlegen, dass nur HTTPS-Verbindungen
                auf Port 443 zugelassen werden, während andere Ports gesperrt
                bleiben.
                <br />
                <br />
                Verdächtige oder unerwünschte Datenpakete – z. B. von bekannten
                bösartigen IP-Adressen – werden <strong>
                  {" "}
                  blockiert.{" "}
                </strong>{" "}
                Firewalls können auch bestimmte Arten von Daten (wie Dateien
                oder Anhänge) filtern, um Malware zu verhindern.
              </p>
              <p className="col-lg-9 mx-auto p-5 m-5 text-decoration-none border-beispiel rounded-2">
                <FirewallUsageChart />
                <small>Quelle: Varonis 2024</small>{" "}
              </p>
            </Element>
          </div>
        </div>
      </div>
      <div className="gelb-section">
        <div className="container">
          <div className="p-5 text-center">
            <Element name="ids">
              <h2 className="p-5">
                {" "}
                <br />
                <br />
                Intrusion Detection System (IDS)
              </h2>
              <p className="col-lg-11 mx-auto">
                Eine Firewall blockiert oder erlaubt den Netzwerkverkehr
                auf Basis bestimmter Regeln (z. B. „erlaube Webverkehr, blockiere
                FTP-Verkehr“). Sie agiert also wie ein Türsteher, der nur
                bekannte oder erlaubte Verbindungen zulässt. <br />
                <br />
                Ein Intrusion Detection System (IDS) geht einen Schritt weiter:
                Es überwacht den Netzwerkverkehr auf verdächtige
                Verhaltensmuster und potenzielle Sicherheitsverletzungen, die
                durch normale Firewall-Regeln nicht erkannt werden können. Ein
                IDS funktioniert wie ein aufmerksamer Sicherheitswächter, der
                nicht nur prüft, <strong>wer </strong> durch die Tür kommt,
                sondern auch beobachtet,{" "}
                <strong> was die Person danach tut. </strong>
                <br />
                <br />
                <br />
                Ein IDS analysiert den Netzwerkverkehr in Echtzeit. <br />
                Das <strong> signaturbasierte IDS </strong> erkennt bekannte
                Angriffsmuster anhand von Datenbank-Signaturen (z. B.
                Malware-Signaturen).
                <br /> Das <strong> verhaltensbasierte IDS </strong>{" "}
                identifiziert Anomalien und ungewöhnliches Verhalten im
                Netzwerkverkehr, auch wenn keine verdächtige Signatur vorhanden
                ist. <br />
                Moderne IDS kombinieren beide Arten zu einem{" "}
                <strong> hybriden IDS, </strong> um maximale Genauigkeit zu
                gewährleisten.
                <br />
                <br />
                <br />
                Ein IDS kann folgende Angriffe erkennen:
              </p>

              <p className=" text-start col-lg-11 mx-auto">
                <ul>
                  <li>
                    <strong>Denial-of-Service-Angriff (DoS): </strong> Massive
                    Anfragen, die ein System überlasten sollen.
                  </li>
                  <li>
                    <strong>Brute-Force-Angriffe: </strong> Mehrfache
                    Login-Versuche, um Passwörter zu erraten. <br />
                  </li>
                  <li>
                    <strong>Datenexfiltration: </strong> Ungewöhnlich große
                    Datenübertragungen von einem Server. <br />
                  </li>
                  <li>
                    <strong>Zero-Day-Angriffe: </strong> Unbekannte
                    Schwachstellen, die durch verhaltensbasierte
                    Anomalieerkennung aufgedeckt werden können.
                  </li>
                </ul>{" "}
              </p>

              <p className="col-lg-11 py-5 mx-auto">
                Ein weiterer Vorteil des IDS ist, dass es{" "}
                <strong>detaillierte Protokolle </strong>und Berichte über den
                gesamten Netzwerkverkehr erstellt. Dies hilft Administratoren
                dabei, Vorfälle zu analysieren und nachzuverfolgen, was genau
                passiert ist, was wichtig für die Fehlerbehebung und forensische
                Analysen nach einem Angriff ist.
                <br />
                <br />
                Ähnlich wie bei Firewalls kann man IDS entweder als physische
                Geräte (Hardware) oder als Software auf Computern oder Servern
                installieren. Hardware-Lösungen bieten umfassenden
                Netzwerkschutz an einem zentralen Punkt wie die Firewall
                (zwischen Router und Internet) oder in einem anderen Abschnitt
                des Netzwerks (innerhalb des internen Netzwerks), während
                Software-Lösungen spezifische Geräte absichern.
                <br />
                <br />
                Eine Firewall und ein IDS ergänzen sich gut. Die Firewall
                übernimmt die grundlegende Sicherheitsaufgabe, indem sie nicht
                erlaubten Verkehr blockiert, während das IDS überwachend tätig
                und auf der Suche nach Verdächtigem innerhalb des erlaubten
                Verkehrs ist.
                <br />
                <br />
              </p>
            </Element>
          </div>
        </div>
      </div>

      <div className="grey-section">
        <div className="container">
          <div className="p-5 text-center">
            <Element name="ips">
              <h2 className="p-5">
                <br />
                <br />
                Intrusion Prevention Systeme (IPS)
              </h2>
              <p className="col-lg-11 mx-auto">
                Das IDS überwacht den Netzwerkverkehr und sucht nach
                verdächtigen Aktivitäten oder bekannten Angriffsmustern. Dabei
                arbeitet es <strong>rein passiv</strong>. Das bedeutet, dass das
                IDS bei der Erkennung einer potenziellen Bedrohung{" "}
                <strong>nur Alarme auslöst</strong> und Administratoren
                benachrichtigt, damit diese reagieren können. Das IDS{" "}
                <strong>greift nicht selbst </strong>in den Netzwerkverkehr ein
                oder blockiert Datenpakete. Es ist sozusagen ein „Beobachter“,
                der genau darauf achtet, was im Netzwerk vor sich geht, und das
                Verhalten protokolliert. Diese Überwachung ist hilfreich, um
                Administratoren auf Bedrohungen aufmerksam zu machen, aber es
                erfordert manuelle Eingriffe, um die Gefahr zu stoppen oder zu
                beseitigen.
                <br />
                <br />
                Im Gegensatz dazu ist das{" "}
                <strong>IPS ein aktives System, </strong> das nicht nur
                Bedrohungen erkennt, sondern auch sofortige Maßnahmen ergreift,
                um Angriffe abzuwehren. Ein IPS überwacht den Datenverkehr
                ebenso wie ein IDS. Aber wenn es eine verdächtige Aktivität oder
                ein Angriffsmuster entdeckt,{" "}
                <strong>
                  wird der potenzielle Angriff automatisch abgewehrt,{" "}
                </strong>
                ohne dass ein Administrator eingreifen muss.
                <br />
                <br />
                Sobald das IPS eine Bedrohung entdeckt, kann es sofort
                Gegenmaßnahmen einleiten, wie z. B.:
                <br />
              </p>
              <p className="text-start col-lg-9 mx-auto">
                <ul>
                  <li>das Blockieren des verdächtigen Datenverkehrs, </li>
                  <li>das Schließen betroffener Verbindungen,</li>
                  <li>das Isolieren gefährdeter Geräte oder Systeme oder</li>
                  <li>
                    das Anpassen von Firewall-Regeln, um ähnliche Angriffe in
                    Zukunft zu verhindern.
                  </li>
                </ul>
              </p>
              <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
                <img
                  src="/images/fact.svg"
                  alt="Transparent"
                  style={{
                    position: "relative",
                    maxWidth: "8%",
                    height: "auto",
                  }}
                />
                In vielen Fällen gilt es als gute Sicherheitsstrategie, IDS und
                IPS gleichzeitig einzusetzen. Ein IDS eignet sich gut, um ein
                Netzwerk detailliert zu überwachen und Administratoren auf
                potenzielle Bedrohungen aufmerksam zu machen, damit sie
                entsprechende Maßnahmen ergreifen können. Es wird oft in
                Überwachungsszenarien eingesetzt, bei denen es auf eine
                sorgfältige Analyse des Netzwerkverkehrs ankommt. Ein IPS
                hingegen ist auf schnelle Reaktion und automatisierten Schutz
                ausgelegt, sodass Angriffe gestoppt werden, bevor sie Schaden
                anrichten können.
              </p>
            </Element>
          </div>
        </div>
      </div>

      <div className="white-section">
        <div className="container">
          <div className="p-5 text-center">
            <Element name="siem">
              <h2 className="p-5">
                <br />
                <br />
                Security Information and Event Management (SIEM){" "}
              </h2>
              <p className="col-lg-11 mx-auto">
                Ein SIEM-System (Security Information and Event Management) ist
                eine zentrale Sicherheitslösung, die Daten und Protokolle aus
                verschiedenen Quellen sammelt, analysiert und korreliert, um
                potenzielle Sicherheitsbedrohungen frühzeitig zu erkennen und
                darauf zu reagieren. Während eine Firewall, ein Intrusion
                Detection System (IDS) und ein Intrusion Prevention System (IPS)
                jeweils spezifische Aufgaben erfüllen, übernimmt das SIEM-System{" "}
                <strong> die Rolle des Koordinators und Analysten.</strong> Es
                verbindet all diese Sicherheitskomponenten miteinander und sorgt
                dafür, dass aus den vielen Einzelinformationen ein
                ganzheitliches Sicherheitsbild entsteht.
                <br />
                <br />
                Das SIEM arbeitet als eine Art Kontrollzentrum, in dem
                Datenströme von der Firewall, dem IDS, dem IPS und weiteren
                Sicherheitskomponenten zusammenlaufen. Während die Firewall
                verdächtige Datenpakete blockiert, das IDS Anomalien erkennt und
                das IPS aktiv Angriffe abwehrt, sammelt das SIEM die
                Informationen all dieser Systeme und wertet sie aus. Dabei geht
                es nicht nur darum, einzelne Ereignisse zu erkennen, sondern{" "}
                <strong> Muster und Zusammenhänge </strong> zu verstehen. <br />
                <br />
                Beispiel: Ein einzelner fehlgeschlagener Login-Versuch mag
                unauffällig sein, doch wenn das SIEM feststellt, dass dieser
                Versuch von mehreren IP-Adressen gleichzeitig erfolgt und in
                kürzester Zeit tausende Logins durchgeführt werden, kann es
                einen koordinierten Brute-Force-Angriff identifizieren.
                <br />
                <br />
                Darüber hinaus spielt das SIEM eine entscheidende Rolle bei der
                <strong>
                  {" "}
                  forensischen Analyse von Sicherheitsvorfällen.{" "}
                </strong>{" "}
                Durch die zentrale Speicherung und Analyse von Log-Daten
                ermöglicht es eine genaue Rückverfolgung von Angriffspfaden. Das
                ist besonders wertvoll, um Schwachstellen im Netzwerk
                aufzudecken und zukünftige Vorfälle zu verhindern. Ebenso
                unterstützt ein SIEM-System Unternehmen dabei,{" "}
                <strong> Compliance-Anforderungen </strong>
                einzuhalten, indem es detaillierte Berichte generiert und
                Sicherheitsvorfälle dokumentiert.
                <br />
                <br />
                Ein weiteres wichtiges Element ist die{" "}
                <strong> Echtzeit-Überwachung: </strong>
                Moderne SIEM-Systeme können nicht nur historische Daten
                analysieren, sondern auch den aktuellen Netzwerkverkehr in
                Echtzeit überwachen. Dadurch werden potenzielle
                Sicherheitsvorfälle schneller erkannt und IT-Teams können
                schneller reagieren.
              </p>
              <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
                <img
                  src="/images/fact.svg"
                  alt="Transparent"
                  style={{
                    position: "relative",
                    maxWidth: "8%",
                    height: "auto",
                  }}
                />
                Ein modernes SIEM-System kann pro Tag mehrere Milliarden
                Log-Daten aus verschiedenen Quellen verarbeiten, darunter
                Firewalls, IDS/IPS-Systeme, Endpunkte, Cloud-Dienste und
                Anwendungen. In großen Unternehmen können diese Systeme bis zu
                10 Terabyte an Sicherheitsdaten täglich analysieren.
              </p>
            </Element>
              <p className="col-lg-11 p-5 mx-auto">

                Dieses Tool soll die Funktionen eines SIEM verdeutlichen. Es simuliert Log‑Daten und zeigt, wie Korrelation-Regeln aus mehreren Einzelereignissen einen Alarm auslösen.
              </p>
            <MiniSIEMLab />
          </div>
        </div>
      </div>

      <div className="container">
        <div
          className="safe rounded-2 text-center"
          style={{ backgroundColor: "#fec748" }}
        >
          <img
            src="/images/abwehr.svg"
            alt="Abwehr"
            style={{
              position: "relative",
              maxWidth: "7%",
              height: "auto",
            }}
          />

          <h3 className="text-center m-5">
            Vergleich: Firewall vs. IDS vs. IPS vs. SIEM
          </h3>
          <div className="table-responsive">
            <table className="table table-bordered table-striped text-center align-middle">
              <thead className="table-light">
                <tr>
                  <th>Eigenschaft</th>
                  <th>Firewall</th>
                  <th>IDS (Intrusion Detection System)</th>
                  <th>IPS (Intrusion Prevention System)</th>
                  <th>SIEM (Security Information and Event Management)</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Funktion</td>
                  <td>
                    Filtert und kontrolliert den Datenverkehr basierend auf
                    definierten Regeln.
                  </td>
                  <td>
                    Überwacht und analysiert Netzwerkverkehr auf verdächtige
                    Aktivitäten.
                  </td>
                  <td>
                    Erkennt und blockiert verdächtigen Datenverkehr in Echtzeit.
                  </td>
                  <td>
                    Sammelt, korreliert und analysiert sicherheitsrelevante
                    Ereignisse aus verschiedenen Quellen.
                  </td>
                </tr>
                <tr>
                  <td>Reaktion</td>
                  <td>Aktiv: Blockiert oder erlaubt Datenverkehr.</td>
                  <td>Passiv: Meldet verdächtige Aktivitäten.</td>
                  <td>
                    Aktiv: Blockiert und verhindert Bedrohungen automatisch.
                  </td>
                  <td>
                    Passiv: Meldet und korreliert Ereignisse, um
                    Bedrohungsmuster zu erkennen.
                  </td>
                </tr>
                <tr>
                  <td>Position im Netzwerk</td>
                  <td>An strategischen Punkten, z. B. Netzwerkperimeter.</td>
                  <td>
                    Überwacht an Netzwerkschnittstellen oder Endpunkten.
                  </td>
                  <td>Inline direkt im Datenverkehrsfluss.</td>
                  <td>
                    Zentral – Agiert als übergreifendes
                    Sicherheits-Kontrollzentrum.
                  </td>
                </tr>
                <tr>
                  <td>Erkennung von Bedrohungen</td>
                  <td>
                    Beschränkt auf vordefinierte Regeln (z. B. Portfreigaben).
                  </td>
                  <td>
                    Erkennt bekannte Angriffsmuster und verdächtiges Verhalten.
                  </td>
                  <td>
                    Erkennt bekannte und unbekannte Bedrohungen durch signatur-
                    und verhaltensbasierte Erkennung.
                  </td>
                  <td>
                    Erkennt Bedrohungsmuster durch Korrelation von Ereignisdaten
                    aus mehreren Quellen.
                  </td>
                </tr>
                <tr>
                  <td>Reaktionszeit</td>
                  <td>Echtzeit: Blockiert sofort nach Regelprüfung.</td>
                  <td>Verzögert: Meldet, Administrator muss reagieren.</td>
                  <td>Echtzeit: Reagiert automatisch und sofort.</td>
                  <td>
                    Verzögert – Ereignisse werden analysiert und Berichte
                    erstellt.
                  </td>
                </tr>
                <tr>
                  <td>Einsatzbereich</td>
                  <td>Perimeter-Schutz, grundlegende Netzwerksicherheit.</td>
                  <td>Forensische Analyse, langfristige Überwachung.</td>
                  <td>Aktiver Schutz vor Angriffen, sofortige Maßnahmen.</td>
                  <td>
                    Zentralisierte Sicherheitsanalyse, Compliance, forensische
                    Analysen.
                  </td>
                </tr>
                <tr>
                  <td>Management-Aufwand</td>
                  <td>Mittel: Regelpflege erforderlich.</td>
                  <td>Hoch: Manuelle Analyse und Reaktion notwendig.</td>
                  <td>Hoch: Regelpflege und Feinabstimmung erforderlich.</td>
                  <td>
                    Hoch: Erfordert kontinuierliche Anpassung und Überwachung.
                  </td>
                </tr>
                <tr>
                  <td>Fehlalarm-Rate</td>
                  <td>Gering: Regelbasiert.</td>
                  <td>Mittel: Anomalien können Fehlalarme verursachen.</td>
                  <td>
                    Mittel bis hoch: Strikte Regeln können legitimen Verkehr
                    blockieren.
                  </td>
                  <td>
                    Mittel: Abhängig von der Qualität der Datenquellen und
                    Korrelationsregeln.
                  </td>
                </tr>
                <tr>
                  <td>Performance-Impact</td>
                  <td>Gering bis mittel.</td>
                  <td>Gering: Arbeitet passiv.</td>
                  <td>
                    Hoch: Inline-Überwachung kann Performance beeinflussen.
                  </td>
                  <td>
                    Mittel bis hoch: Datenanalyse kann ressourcenintensiv sein.
                  </td>
                </tr>
                <tr>
                  <td>Beispiel-Anwendung</td>
                  <td>
                    Kontrolle von Netzwerkzugriffen und Traffic-Filterung.
                  </td>
                  <td>
                    Erkennung von verdächtigen Aktivitäten (z. B. DoS-Angriffe).
                  </td>
                  <td>
                    Aktive Blockierung von Angriffen (z. B. SQL-Injection,
                    Malware).
                  </td>
                  <td>
                    Übergreifende Analyse und Korrelation von
                    Sicherheitsereignissen.
                  </td>
                </tr>
                <tr>
                  <td>Tools/Beispiele</td>
                  <td>Cisco ASA, pfSense, FortiGate.</td>
                  <td>Snort, Suricata, OSSEC.</td>
                  <td>
                    Palo Alto Networks, Cisco Firepower.
                  </td>
                  <td>Splunk, IBM QRadar, Microsoft Sentinel.</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      {/* Fragenteil */}
      <div className="container pt-5 my-5">
        <div className="text-center m-4">
          <h2>Überprüfe dein Wissen</h2>
          <p className="col-lg-11 mx-auto">
            Mit den richtigen Antworten kommst du weiter!
          </p>
        </div>
        <div className="row justify-content-center">
          <div className="col-md-9 text-start">
            <form onSubmit={handleSubmit}>
              {questions.map((question, index) => (
                <div key={index} className="mb-4">
                  <p className="fs-4">{question.question}</p>{" "}
                  {question.options.map((option) => (
                    <div key={option.value} className="form-check">
                      <input
                        className="form-check-input me-2"
                        type="radio"
                        name={`question${index}`}
                        value={option.value}
                        checked={selectedAnswers[index] === option.value}
                        onChange={() => handleAnswerChange(index, option.value)}
                      />
                      <label className="form-check-label fs-5">
                        {option.label}
                      </label>{" "}
                    </div>
                  ))}
                </div>
              ))}
              {error && <p className="text-danger">{error}</p>}
              <div className="text-center">
                <button type="submit" className="btn btn-primary">
                  überprüfen
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* Ende Fragenteil */}
    </div>
  );
};

export default Chapter4_3;
